<template>
  <div class="flex flex-col shadow-lg transition duration-500 transition-all ease-linear">
    <div
        class="rounded-t bg-gradient-to-r from-gray-600 via-gray-500 to-gray-400  p-4 flex justify-between items-center w-full ">
      <h4 class="text-lg font-semibold text-white">{{ faculty.name }}</h4>
      <a class="py-0.5 px-2 font-medium text-gray-100 transition duration-500 ease-in-out hover:text-pink-600 rounded-md"
         :href="`/static/pdf/${dir}/cv/${faculty.cv}`" type="application/pdf" target="_blank">
        View Profile
      </a>
    </div>

    <div class="flex flex-wrap justify-center items-center md:justify-between rounded-b p-5 gap-5 border-1 border-collapse border-gray-200 border-t-0">
      <img
          class="object-fill rounded-lg transition duration-500 ease-in-out transform  hover:scale-105 w-full sm:w-1/4"
          :src="`/static/images/${dir}/faculty/${faculty.image}.jpg`" alt="">
      <div class="flex flex-col w-full sm:w-2/3">
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Designation:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.designation }}</span>
        </div>
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Qualification:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.qualification }}</span>
        </div>
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Experience:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.experience }}</span>
        </div>
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Specialization:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.specialization }}</span>
        </div>
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Contact No.:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.contact }}</span>
        </div>
        <div class="flex justify-self-center border-b pb-1 mb-2 border-gray-300">
          <span class="flex-1 font-medium text-gray-800">Email:</span>
          <span class="flex-1 text-gray-600 font-medium">{{ faculty.email }}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FacultyCard",
  props: {
    faculty: Object,
    dir: String
  }
}
</script>

<style lang="scss" scoped/>